const DEFAULT_LOCALE = 'ru';
export function replace(path) {
    const locale = window.lang || window.locale || 'ru'
    const pathTrimmed = path.replace(/^\/+/, '').replace(/\/+$/, '')
    if (locale === DEFAULT_LOCALE) {
        window.history.replaceState({}, document.title, `/${pathTrimmed}`);
        return
    }
    
    window.history.replaceState({}, document.title, `/${locale}/${pathTrimmed}`);
}